<div class="mat-grid p-4">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table">
    <ng-container [matColumnDef]="column" *ngFor="let column of columnsToDisplay">
      <th mat-header-cell class="headerText" *matHeaderCellDef> {{column}} </th>
      <td mat-cell class="cell-data" *matCellDef="let element">

        <span *ngIf="!isAction; else actionIcons">{{element[column]}}</span>
        <ng-template #actionIcons>
          <span>{{element[column]}}</span>
          <span *ngIf="column == 'Actions'">
            <button matTooltip="View" mat-icon-button (click)="viewFunction(element.id)">
              <span class="material-symbols-outlined">visibility</span>
            </button>
            <button class="ml-2 mr-2" matTooltip="Copy" mat-icon-button (click)="copyFunction(element.id)">
              <span class="material-symbols-outlined">move_group</span>
            </button>
            <button class="ml-2 mr-2" matTooltip="Edit" mat-icon-button (click)="editFunction(element.id)">
              <span class="material-symbols-outlined">edit</span>
            </button>
            <button class="ml-2 mr-2" matTooltip="Delete" mat-icon-button (click)="deleteTraining(element.id)">
              <span class="material-symbols-outlined">delete</span>
            </button>
          </span>
        </ng-template>
      </td>
    </ng-container>
    <tr mat-header-row class="tableRows" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row class="tableRows" *matRowDef="let row; columns: columnsToDisplay;"></tr>
    <tr class="mat-row" *ngIf="dataSource.length<=0">
      <td class="mat-cell" [attr.colspan]="columnsToDisplay.length">
        No Records Found.
      </td>
    </tr>
  </table>
  <div class="no-record" *ngIf="dataSource.length<=0">No Records found</div>
</div>